// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/folder-plus.js';

import { paths } from '../generated/folder-plus';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('folder-plus', Original, paths);
